import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Typography, Paper } from "@material-ui/core";
import SearchingForm from "../Component/SearchingForm.js";
import ResultTable from "../Component/ResultTable.js";
import Notice from "../Component/Notice.js";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  root: {
    padding: theme.spacing(5),
  },
  headerGrid: {},
  leftGrid: {},
}));

function SearchPage() {
  const classes = useStyles();

  const [searchData, setSearchData] = useState([]);
  const [searchField, setSearchField] = useState("");

  async function fetchData() {
    const result = await axios.get("https://pub-api.paysable.com/search/" + searchField);
    var newArray = [result.data, ...searchData];
    setSearchData([...newArray.slice(0, 5)]);
  }

  const searchFieldHandler = (event) => {
    var localTrackingNumber = event.target.value;
    var fixed = localTrackingNumber.replace(/[^0-9a-zA-Z]/g, "");
    setSearchField(fixed);
  };

  const searchSubmitHandler = (e) => {
    e.preventDefault(e);
    fetchData();
  };

  return (
    <div className={classes.main}>
      <Container className={classes.root} component={Paper} maxWidth="md">
        <Grid container justify="center" spacing={5}>
          <Grid className={classes.headerGrid} item xs={12}>
            <Typography variant="h4" gutterBottom>
              Package Arrival Search
            </Typography>
            <Typography variant="subtitle1">Check your package arrival status with a local tracking number</Typography>
          </Grid>
          <Grid className={classes.leftGrid} item xs={12} sm={6}>
            <Notice />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SearchingForm searchFieldHandler={searchFieldHandler} searchSubmitHandler={searchSubmitHandler} trackingNumber={searchField} />
            <ResultTable searchData={searchData} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default SearchPage;
